export * from './IconPolygonBlue';
